import apiClient from './client';

export interface RobotBinding {
  robot_id: string;
  robot_name: string;
  bound_at: string;
}

export async function getRobotBindings(): Promise<RobotBinding[]> {
  const response = await apiClient.get('/robots/bindings');
  return response.data;
}

export async function bindRobot(robot_ak: string): Promise<void> {
  await apiClient.post('/robots/bindings', { robot_ak });
}
